const enumeraciones = {};

enumeraciones.TiposFormatos = {
    ListaDeVinculos: 1, 
    CartasConVinculos: 2, 
    TablaDeVinculos: 3, 
    VinculoConModal: 4, 
    TablaConTexto: 5, 
    Transparencia: 6, 
    Embebido: 7,
    TextoYBotonConVinculo: 9,
    CarruselConContexto: 10, 
    Mapa: 13,
    SoloTexto: 23,
    TocasElectorales: 33,
    NotificacionesCiviles: 44,
    ConsultaPublicaAudiencias: 45,
    ConsultaPublicaSentencias: 46,
    BOLSA_DE_TRABAJO: 49,
    VALIDADOR_FIRMA_ELECTRONICA: 52
}

enumeraciones.EstadosDeCarga = {
    Cargando: 0, 
    Cargado: 1, 
    Error: 2
}

enumeraciones.TiposFormatoMicrositios = {
    RouterHover:8,  //ya
    CarruselYTexto:15, //
    Imagen:16, //ya
    Video:17,  
    VinculoModalMicrositio:18, //YA
    CajaConVinculo:19, //
    ImagenConVinculo:20,  //
    ImagenTextoLinkAlFinal:21, //
    Pestanas:22,   //
    Texto:24,   //
    ListaTexto:25, //
    Contacto:26,  
    MapaContacto:27, 
    VinculosHover:28,  //
    TablaDescripcionYLink:29,//
    TablaDeTexto:30,    //
    CarruselSimple:32, //
    ContenidoConTabla:47, //
    SelectSimple:50
}
enumeraciones.Recursos={
    IpAccesoServidorArchivos: 'https://themisfsweb.poderjudicialags.gob.mx',
    IpAccesoServidorCarpeta: '\\\\themisfstest\\Files'
},

enumeraciones.TiposFormatoIntranet = {
    CarruselSimple: 32,
    TarjetaDeEnlaces: 35, // agregar a BD una vez creada las tablas de intranet
    ContenedorDeEnlaces: 36, // agregar a BD una vez creada las tablas de intranet
    ListadoDeDocumentosArea: 37, // agregar a BD una vez creada las tablas de intranet,
    FormularioEnvioEdictos: 38, // agregar a BD una vez creada las tablas de intranet,
    ContenedorMaterialArea: 39, // agregar a BD una vez creada las tablas de intranet,
    TarjetaSesiones: 40, // agregar a BD una vez creada las tablas de intranet,
    ContenedorDeConvocatorias: 41, // agregar a BD una vez creada las tablas de intranet,
    CarruselNoticias: 42, // agregar a BD una vez creada las tablas de intranet,
    TablaComunicados: 43 // agregar a BD una vez creada las tablas de intranet,
}

enumeraciones.TiposClinicasIntranet = {
    CIVIL: 1,
    MERCANTIL: 3,
    FAMILIAR: 5,
    PENAL: 7
}

export default enumeraciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/enumeraciones/sicpo.js
// module id = WcEb
// module chunks = 2